//import '../node_modules/@boldreports/javascript-reporting-controls/Content/material/bold.reports.all.min.css';
import jquery from 'jquery';
import createReactClass from 'create-react-class';

window['createReactClass'] = createReactClass;
window['$'] = window['jQuery'] = jquery;